import { FC } from 'react';
import { Row, Typography } from 'antd';

import { useAppSelector, useTranslate } from 'hooks';
import { language } from 'utils';
import { RequestStatus } from 'utils/constants';

import { CountryFlag } from 'componets/ui';
import styles from "../../../../../componets/layouts/AccountLayout/index.module.scss";
import { ReactComponent as BackIcon} from '../../../../../assets/icons/back.svg'
import {useNavigate} from "react-router-dom";

export const ProjectTitle: FC = () => {
	const navigate = useNavigate();
	const { offeredByText } = useTranslate(['offeredByText']);

	const { item: project, status } = useAppSelector((state) => state.primaryMarket);

	const isNotFulfilled = status !== RequestStatus.FULFILLED;

	if (isNotFulfilled) return <></>;

	return (
		<>
			<Typography.Text className="primaryItem__title">
				<div className={styles.titleWithBack}>
					<a onClick={() => navigate(-1)}><BackIcon /></a>
					<>{project.title}</>
				</div>
			</Typography.Text>
			<Row className="primaryItem__row">
				<Typography.Text className="primaryItem__row">
					{project.country?.iso && <CountryFlag country={project.country.iso} />}
					{project.country?.title === 'Lithuania' && language === 'lt'
						? 'Lietuva'
						: project.country?.title}
				</Typography.Text>
				&nbsp;·&nbsp;
				<div className="primaryItem__row">
					{offeredByText}&nbsp;
					<Typography.Text>{project.originator?.originatorTitle}</Typography.Text>
				</div>
			</Row>
		</>
	);
};
